import Lexer from './Lexer';
import parse, { LexemeType } from '.';

export default class Parser {
  private lexer: Lexer;

  constructor(lexer: Lexer) {
    this.lexer = lexer;
  }

  parse(): string {
    let lexeme;
    let result = '';

    do {
      lexeme = this.lexer.getLexeme();
      switch (lexeme.type) {
        case LexemeType.BOLD: {
          const text = lexeme.token.slice(1, lexeme.token.length - 1);
          if (lexeme.token.length > 2) {
            result += '<strong>' + parse(text) + '</strong>';
          } else {
            result += lexeme.token;
          }
        }
          break;
        case LexemeType.ITALIC: {
          const text = lexeme.token.slice(1, lexeme.token.length - 1);
          if (lexeme.token.length > 2) {
            result += '<em>' + parse(text) + '</em>';
          } else {
            result += lexeme.token;
          }
        }
          break;
        case LexemeType.DASHED: {
          const text = lexeme.token.slice(1, lexeme.token.length - 1);
          if (lexeme.token.length > 2) {
            result += '<del>' + parse(text) + '</del>';
          } else {
            result += lexeme.token;
          }
        }
          break;
        case LexemeType.CODE: {
          const text = lexeme.token.slice(3, lexeme.token.length - 3);
          if (lexeme.token.length > 6) {
            result += '<code>' + text + '</code>';
          } else {
            result += lexeme.token;
          }
        }
          break;
        case LexemeType.TEXT: 
          result += lexeme.token;
          break;
        default:
          throw new Error('Invalid type!');
      }
    } while (lexeme.token !== '');

    return result;
  }
}